import React, { Component } from 'react';
import { Typography } from '@material-ui/core';
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css';
import { Button } from 'react-bootstrap';
import { PostData } from '../../api/service';
import Snack from '../Snackbar/Snack';


class DepartmentContact extends Component {
    state = {
        contact_details: '',
        dept_code: this.props.dept_code,
        message: '',
        open: false
    }

    handleChange = (name, value) => {
        this.setState({
            [name]: value
        })
    }

    componentDidMount() {
        if (this.props.contact_details != null) {
            this.setState({
                contact_details: this.props.contact_details
            })
        }

    }


    onSubmit = (e) => {
        e.preventDefault();

        let d = {
            value: this.state.contact_details,
            type: 'contact_details',
            dept_code: this.props.dept_code
        }

        PostData(`/admin/${this.props.dept_code}/uploaddata`, d)
            .then((resp) => {
                //console.log(resp)
                this.setState({
                    message: resp,
                    open: true
                })
            })
    }


    render() {
        return (
            <div>

                {this.state.open ? (
                    <Snack
                        open={this.state.open}
                        message={this.state.message}
                        handleClose={() => {
                            this.setState({
                                open: false,
                                message: ''
                            })
                        }}
                    />
                ) : null}

                <form onSubmit={this.onSubmit}>
                    <Typography
                        variant="h6"
                    >
                        Departmental Contact Details
                    </Typography>

                    <ReactQuill
                        placeholder="Type something here"
                        value={this.state.contact_details}
                        onChange={this.handleChange.bind(this, 'contact_details')}
                    />

                    <br />

                    <div align="right">
                        <Button
                            size="sm"
                            variant="info"
                            type="submit"
                        >
                            Submit
                    </Button>
                    </div>

                </form>
            </div>
        );
    }
}


export default DepartmentContact;


// WEBPACK FOOTER //
// ./src/Components/Department/DepartmentContact.js